












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "affiliates-customer-controls-warning": () =>
      import(
        "@/components/app/global/affiliate/affiliatesCustomerControlsWarning.vue"
      )
  }
})
export default class AdminAffiliatesView extends Vue {
  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;
}
